/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkOrganisationOtherDTO
 */
export interface WorkOrganisationOtherDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkOrganisationOtherDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrganisationOtherDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrganisationOtherDTO
     */
    role?: string;
}

/**
 * Check if a given object implements the WorkOrganisationOtherDTO interface.
 */
export function instanceOfWorkOrganisationOtherDTO(value: object): value is WorkOrganisationOtherDTO {
    return true;
}

export function WorkOrganisationOtherDTOFromJSON(json: any): WorkOrganisationOtherDTO {
    return WorkOrganisationOtherDTOFromJSONTyped(json, false);
}

export function WorkOrganisationOtherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrganisationOtherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'name': json['name'] == null ? undefined : json['name'],
                  'role': json['role'] == null ? undefined : json['role'],
    };
}

export function WorkOrganisationOtherDTOToJSON(json: any): WorkOrganisationOtherDTO {
    return WorkOrganisationOtherDTOToJSONTyped(json, false);
}

export function WorkOrganisationOtherDTOToJSONTyped(value?: WorkOrganisationOtherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'role': value['role'],
    };
}


